import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from '../modal/modal.service';
import { OrderService } from '@app/core/business/order/order.service';
import { ContextService } from '@app/core/service/context.service';
import { Order } from '@app/core/business/order/order';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-order-selector-modal',
  templateUrl: './order-selector-modal.component.html',
  styleUrls: ['./order-selector-modal.component.scss'],
})
export class OrderSelectorModalComponent implements OnInit, OnDestroy {
  public loading = false;
  public orders: Order[];

  constructor(
    private modalService: ModalService,
    private orderService: OrderService,
    private contextService: ContextService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.orderService
      .getOrders(
        this.contextService.context.companyCode,
        this.contextService.context.customerCode,
        true
      )
      .pipe(untilDestroyed(this))
      .subscribe(
        orders => {
          this.orders = orders;
          this.loading = false;
        },
        error => {
          this.cancel();
        }
      );
  }

  ngOnDestroy() {}

  public cancel(): void {
    this.modalService.cancel();
  }

  public validate(selectedOrderCode: string): void {
    this.modalService.validate(selectedOrderCode);
  }
}
